export default __webpack_public_path__ + "static/media/LedgerIcon.29293421.png";